export function isIosDevice () {
    const userAgent = window.navigator.userAgent;

    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return true;
    }

    return /Macintosh/.test(userAgent) && window.navigator.maxTouchPoints > 1;
}
